/* Adds keyboard support to Turbo's existing mobile menu interactions. */
(() => {
  let submenuId = 0;

  function enhanceMenu(menu) {
    menu.querySelectorAll('li.sublink > a').forEach(link => {
      const submenu = link.nextElementSibling;
      if (!submenu || submenu.tagName !== 'UL') return;
      const href = link.getAttribute('href');
      const navigates = href && href !== '/' && !href.includes('#');
      if (!submenu.id) submenu.id = `leavys-submenu-${++submenuId}`;
      const row = document.createElement('div');
      row.className = 'leavys-menu-row';
      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'leavys-submenu-toggle';
      control.setAttribute('aria-controls', submenu.id);
      control.setAttribute('aria-expanded', 'false');
      const icon = document.createElement('span');
      icon.className = 'icon-down-arrow';
      icon.setAttribute('aria-hidden', 'true');
      link.querySelectorAll('.icon-down-arrow').forEach(arrow => arrow.remove());
      const title = link.textContent.trim();
      link.before(row);
      if (navigates) {
        row.append(link);
        control.setAttribute('aria-label', `Toggle ${title} menu`);
      } else {
        control.textContent = title;
        control.classList.add('leavys-submenu-toggle--full');
        link.remove();
      }
      control.append(icon);
      row.append(control);
      submenu.hidden = true;
      submenu.style.display = 'none';
    });
  }

  function init() {
    const menu = document.getElementById('mobile_menu');
    const drawer = document.querySelector('[data-mobile-menu]');
    if (!menu || !drawer || menu.dataset.leavysEnhanced) return;
    menu.dataset.leavysEnhanced = 'true';
    enhanceMenu(menu);
    // Theme-editor section reloads can replace injected mega-menu items.
    const observer = new MutationObserver(() => enhanceMenu(menu));
    observer.observe(menu, {childList: true, subtree: true});
    menu.addEventListener('click', event => {
      const control = event.target.closest('.leavys-submenu-toggle');
      if (!control) return;
      const submenu = document.getElementById(control.getAttribute('aria-controls'));
      if (!submenu) return;
      const open = control.getAttribute('aria-expanded') !== 'true';
      control.setAttribute('aria-expanded', String(open));
      submenu.hidden = !open;
      submenu.style.display = open ? 'block' : 'none';
    });
    drawer.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !drawer.open) return;
      event.preventDefault();
      if (window.mobileMenuDrawer) window.mobileMenuDrawer.close();
      else drawer.open = false;
      drawer.querySelector('summary').focus();
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(menu)) observer.disconnect();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(init));
})();
